import { ClientOnly } from "remix-utils/client-only";
export const Emoji: React.FC<{ emojiId?: string | null | undefined }> = ({ emojiId }) => {
  if (!emojiId)
    return (
      <div className="rounded-lg w-6 h-6 flex items-center justify-center">
        <img src="/assets/images/avatar.png" className="w-5 h-5" />
      </div>
    );
  return (
    <ClientOnly>
      {() => {
        return (
          <div className="rounded-lg">
            {/* @ts-ignore */}
            <em-emoji id={emojiId} size="24px" />
          </div>
        );
      }}
    </ClientOnly>
  );
};
